import React, { useState } from "react";
import { Input, Table } from "semantic-ui-react";
import styles from "./BudgetPeriodDetails.css";


const BudgetPeriodDetail = props => {
	const { sortedTeam, onChange, researchTeamBudgetPeriod } = props;

	const [ localResearchTeamBudgetPeriod, setLocalResearchTeamBudgetPeriod ] = useState(researchTeamBudgetPeriod);

	function getNumberOrZero (value) {
		return value === undefined ? 0 : value;
	}

	const setEffortValue = (event, member, field) => {
		let researchTeamMember = localResearchTeamBudgetPeriod.researchTeam[member.id];
		if (researchTeamMember !== null) {
			researchTeamMember[field] = event.target.value;

			let totalEffort = 0;
			if (researchTeamMember.isCalendarAppointment) {
				totalEffort += +getNumberOrZero(researchTeamMember.costShareEffortC);
				totalEffort += +getNumberOrZero(researchTeamMember.sponsoredEffortC);
			}
			if (researchTeamMember.isAcademicAppointment) {
				totalEffort += +getNumberOrZero(researchTeamMember.costShareEffortA);
				totalEffort += +getNumberOrZero(researchTeamMember.sponsoredEffortA);
			}
			if (researchTeamMember.isCalendarAppointment) {
				totalEffort += +getNumberOrZero(researchTeamMember.costShareEffortS);
				totalEffort += +getNumberOrZero(researchTeamMember.sponsoredEffortS);
			}

			localResearchTeamBudgetPeriod.researchTeam[member.id].totalEffort = totalEffort;
		}

		const newResearchTeamBudgetPeriod = JSON.parse(JSON.stringify(localResearchTeamBudgetPeriod));
		onChange(newResearchTeamBudgetPeriod);
		setLocalResearchTeamBudgetPeriod(newResearchTeamBudgetPeriod);
	};

	return (
		<>
			< h1> BUDGET DETAILS </h1>
			{localResearchTeamBudgetPeriod && (
				<div className={styles.effortTable}>
					<Table>
						<caption>Budget Details</caption>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Name</Table.HeaderCell>
								<Table.HeaderCell>Internal Association</Table.HeaderCell>
								<Table.HeaderCell colSpan={3}>Cost Share Effort %</Table.HeaderCell>
								<Table.HeaderCell colSpan={3}>Sponsored Effort %</Table.HeaderCell>
								<Table.HeaderCell>Total Effort</Table.HeaderCell>
							</Table.Row>
							<Table.Row>
								<Table.HeaderCell/>
								<Table.HeaderCell/>
								<Table.HeaderCell>C</Table.HeaderCell>
								<Table.HeaderCell>A</Table.HeaderCell>
								<Table.HeaderCell>S</Table.HeaderCell>
								<Table.HeaderCell>C</Table.HeaderCell>
								<Table.HeaderCell>A</Table.HeaderCell>
								<Table.HeaderCell>S</Table.HeaderCell>
								<Table.HeaderCell/>
							</Table.Row>
						</Table.Header>
						{sortedTeam.map(member => {
							const researchTeamPeriod = localResearchTeamBudgetPeriod.researchTeam[member.id];

							return (
								<Table.Body key={member.id}>
									<Table.Row>
										<Table.Cell>{member.name}</Table.Cell>
										<Table.Cell>{member.association}</Table.Cell>
										<Table.Cell>
											<Input type={"number"}
												id={member.id + "CSEC"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isCalendarAppointment}
												value={researchTeamPeriod?.costShareEffortC}
												onChange={event => setEffortValue(event, member, "costShareEffortC")}
											/>
										</Table.Cell>
										<Table.Cell>
											<Input type={"number"}
												id={member.id + "CSEA"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isAcademicAppointment}
												value={researchTeamPeriod?.costShareEffortA}
												onChange={event => setEffortValue(event, member, "costShareEffortA")}
											/>
										</Table.Cell>
										<Table.Cell>
											<Input type={"number"}
												id={member.id + "CSES"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isSummerAppointment}
												value={researchTeamPeriod?.costShareEffortS}
												onChange={event => setEffortValue(event, member, "costShareEffortS")}
											/>
										</Table.Cell>

										<Table.Cell>
											<Input type={"number"}
												id={member.id + "SEC"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isCalendarAppointment}
												value={researchTeamPeriod?.sponsoredEffortC}
												onChange={event => setEffortValue(event, member, "sponsoredEffortC")}
											/>
										</Table.Cell>
										<Table.Cell>
											<Input type={"number"}
												id={member.id + "SEA"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isAcademicAppointment}
												value={researchTeamPeriod?.sponsoredEffortA}
												onChange={event => setEffortValue(event, member, "sponsoredEffortA")}

											/>
										</Table.Cell>
										<Table.Cell>
											<Input type={"number"}
												id={member.id + "SES"}
												placeholder={0}
												min={"1"} max={"100"} disabled={!member.isSummerAppointment}
												value={researchTeamPeriod?.sponsoredEffortS}
												onChange={event => setEffortValue(event, member, "sponsoredEffortS")}
											/>
										</Table.Cell>
										<Table.Cell>
											{member.totalEffort < 101 && member.totalEffort > -1 ?
												(
													<label>
														{researchTeamPeriod?.totalEffort}
													</label>
												) : (
													<p className={styles.error}>1-100</p>
												)
											}
										</Table.Cell>
									</Table.Row>
								</Table.Body>

							);
						})}
					</Table>
				</div>
			)}
		</>
	);
};
export default BudgetPeriodDetail;








